import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import formatTimestamp from '../../../i18n/formatTimestamp';

import { Spinner } from '@salesforce/design-system-react';

import './AuditTable.scss';

class AuditTable extends Component {
  renderAudit() {
    const { formatMessage } = this.props.intl;
    const formatDate = formatTimestamp(this.props.intl);
    const i18nKey = 'components.ecs.selectionBrowser.profile';
    const title = `${i18nKey}.audit.title`;
    const items = this.props.auditLog || [];

    return (
      <div className="audit-table-container">
        <div className="audit-title-row">
          <h3>
            <FormattedMessage id={title} />
          </h3>
        </div>
        {items.map(item => {
          return (
            <ul key={`item-${item.timestamp}`}>
              <div className="audit-list">
                <span className="audit-item">
                  {formatMessage({
                    id: `${i18nKey}.audit.${item.old_values.status.toLowerCase()}_to_${item.new_values.status.toLowerCase()}`
                  })}
                </span>
                <span className="audit-item">
                  {formatMessage({ id: `${i18nKey}.audit.timestamp` })} -{' '}
                  {formatDate(item.timestamp)}
                </span>
                <span className="audit-item">
                  {formatMessage({ id: `${i18nKey}.audit.user` })} -{' '}
                  {item.user_email}
                </span>
              </div>
            </ul>
          );
        })}
      </div>
    );
  }

  drawSpinner(isLoading) {
    return isLoading ? (
      <div className="pi-common-spinner">
        <Spinner variant="brand" />
      </div>
    ) : null;
  }

  render() {
    const { isLoading } = this.props;

    return (
      <React.Fragment>
        {this.renderAudit()}
        {this.drawSpinner(isLoading)}
      </React.Fragment>
    );
  }
}

AuditTable.contextTypes = {
  router: PropTypes.object
};

AuditTable.propTypes = {
  actions: PropTypes.object,
  auditLog: PropTypes.array,
  isLoading: PropTypes.bool,
  location: PropTypes.object
};

export default injectIntl(AuditTable);
